import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react"
import { getAuthModel } from "../../auth"
import { Widget } from "./widgetModel";

const API3_URL : string | undefined  = process.env.REACT_APP_API_URL

export  const auth = getAuthModel();

export const widgetsApi = createApi({
    reducerPath: "widgetsApi",
    baseQuery: fetchBaseQuery({         
        baseUrl: `${API3_URL}`, 
        prepareHeaders: (headers, { getState }) =>{  
            const auth = getAuthModel()              
            if (auth?.access_token) {
                headers.set('authorization', `Bearer ${auth.access_token}`)
            }            
            return headers
        }
    }),
    tagTypes: ['Widget'],
    refetchOnMountOrArgChange: 30,    
    
    endpoints: (builder) => ({

        getAllWidgets : builder.query<Widget[], number>({
            query: () => `widget`,
            providesTags: ['Widget'],
            keepUnusedDataFor: 5,              
        })
        
    })
});

export const {
    useGetAllWidgetsQuery
} = widgetsApi